import { create } from '@storybook/theming/create'

export default create({
  base: 'light',
  brandTitle: 'Experience NTU UI - Storybook',
  brandImage: 'https://i.imgur.com/4BtoFw0.png',
  brandTarget: '_self',

  colorPrimary: '#933243',
  colorSecondary: '#BC9631'
})
